module.exports = __webpack_public_path__ + "img/close-little-black.1ac665db.svg";